'use strict';

import $ from 'jquery';
import _ from 'lodash';
import RBush from 'rbush';
import { Signal } from 'signals';

import tooltipTMPL from './tooltip.tmpl';
import tooltipCSS from './tooltip.styl';

export default class MapTooltip {

  constructor(lmap, $container) {
    this._lmap = lmap;
    this._$container = $container;

    this._$tooltip = $('<div id="tooltip"></div>');
    this._$container.append(this._$tooltip);
    this._onMove = _.throttle(e => this._onMapMouseMove(e), 100, {trailing: false});

    this._lmap.on('dragstart', e => this._onMapDragStart(e));
    this._lmap.on('dragend', e => this._onMapDragEnd(e));
    this._lmap.on('mouseout', e => this._onMapMouseOut(e));
    this._lmap.on('mouseup', e => this._onMapMouseUp(e));

    this._nodes = {};
    this._hidden = {};
    this.itemClicked = new Signal();
    this._rTree = new RBush(9);
  }

  updateLocations(data) {
    if (!data) return;
    this._nodes = data.map(d => [d.lat, d.lng, d.lat, d.lng, d]).filter(d => !isNaN(d[0]));
    this._rTree.clear();
    this._rTree.load(this._nodes);
  }

  _showTooltip(d) {
    if (!d) {
      if (this._tooltipTimer) return;
      this._tooltipTimer = _.delay(() => {
        this._$tooltip.hide();
        this._activeItem = null;
        this._tooltipTimer = null;
      }, 250);
      return;
    }

    if (d !== this._activeItem && !this._dragging) {
      this._activeItem = d;
      this._$tooltip.html(tooltipTMPL(d));
      this._$tooltip.show();
      if (this._tooltipTimer) {
        clearTimeout(this._tooltipTimer);
        this._tooltipTimer = null;
      }
    }
  }

  _onMapMouseMove(e) {
    if (this._dragging) this._$tooltip.hide();

    this._$tooltip.css('top', e.originalEvent.pageY - 10);
    this._$tooltip.css('left', e.originalEvent.pageX + 10);

    const fc = 0.000004 * Math.pow(2, 21 - this._lmap.getZoom());
    const rs = this._rTree.search([e.latlng.lat - fc, e.latlng.lng - fc, e.latlng.lat + fc, e.latlng.lng + fc]);
    if (rs.length) {
      rs.splice(5);
      this._showTooltip({ data: rs.map(d => d[4]).sort((a,b) => a.full_address > b.full_address) }, e);
      $('#map').css('cursor', 'pointer');
    } else {
      this._showTooltip(null);
      $('#map').css('cursor', 'default');
    }
  }

  _onMapMouseUp() {
    if (this._activeItem && !this._dragging) this.itemClicked.dispatch(this._activeItem);
  }

  _onMapDragStart() {
    this._dragging = true;
    this._showTooltip(null);
  }

  _onMapDragEnd() {
    this._dragging = false;
  }

  _onMapMouseOut() {
    this._$tooltip.hide();
    this._activeItem = null;
    this._tooltipTimer = null;
  }

  hide(collName) {
    this._hidden[collName] = true;
    this._mergeNodes();
  }

  show(collName) {
    this._hidden[collName] = false;
    this._mergeNodes();
  }

  disable() {
    this._$tooltip.hide();
    this._lmap.off('mousemove click', this._onMove, this);
  }

  enable() {
    this._lmap.on('mousemove click', this._onMove, this);
  }

}



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/map/tooltip/MapTooltip.es6
 **/